import { Producto, Productos } from '@/interface/producto.model';
import { FechaFunctionsService } from '@/utils/functions.service';
import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { GeneralService } from '@services/general.service';
import { LoadingService } from '@services/loading.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ToastrService } from 'ngx-toastr';

interface DetalleArqueo {
  id_tipopago: number;
  nombre_tipopago: string;
  sistemaValue: number;
  inputValue: number;
  sum?: number;
}

@Component({
  selector: 'app-detalle-arqueo',
  templateUrl: './detalle-arqueo.component.html',
  styleUrls: ['./detalle-arqueo.component.scss']
})
export class DetalleArqueoComponent {
  @Input() label: string = "Todos los pedidos";
  @Input() rows: Array<any>;
  @Input() tempRows: Array<any>;
  @Input() isLoading: boolean = false;
  @Input() mini: boolean = false;
  @Input() onlyMedioPago: boolean = false;
  @Input() showCliente: boolean = true;
  @Input() showHeader: boolean = true;
  @Input() showFooter: boolean = true;
  @Input() sortByKey: string = 'fecha_termino';
  @Input() reverseSort: boolean = true;
  @Output() updateData = new EventEmitter();
  @Output() updateDataMedioPago = new EventEmitter();
  @ViewChild('table') table: DatatableComponent;
  nowDay: string = this.Func.NowDay();
  nextDay: string = this.Func.NextDay();
  messages: any;
  itemsPerPage: number = 50;
  page: number = 1;
  estados: Array<any>;
  sistemaValueTotal: number = 0;
  inputValueTotal: number = 0;
  sumTotal: number = 0;

  constructor(private router: Router,
    public generalService: GeneralService,
    private toastr: ToastrService,
    public Func: FechaFunctionsService,
    public loadingService: LoadingService) {
  }

  ngOnInit() {
    this.getDataDetalle();
  }

  async getDataDetalle() {
    try {
      this.isLoading = true;
      let queryParam: string = "?fecha_pago=" + this.Func.NowDay();
      let res = await this.generalService.getListar(`arqueo/detalle${queryParam}`)
      this.rows = res.data.map(row => ({
        id_tipopago: row.id_tipopago,
        nombre_tipopago: row.nombre_tipopago,
        sistemaValue: row.Sistema,
        inputValue: 0,
        sum: 0 - row.Sistema
      }));
      this.updateRows();
      this.updateAllSums(); // Actualiza todos los totales
      this.isLoading = false;
    } catch (error) {
      console.log(error)
      this.isLoading = false;
    }
  }

  updateSum(row: DetalleArqueo) {
    row.sum = Number(row.inputValue) - Number(row.sistemaValue);
    this.updateAllSums(); // Actualiza todos los totales
  }

  updateAllSums() {
    // Calcular los totales
    const sistemaValueTotal = this.rows.reduce((sum, row) => sum + Number(row.sistemaValue), 0);
    const inputValueTotal = this.rows.reduce((sum, row) => sum + Number(row.inputValue), 0);
    const sumTotal = this.rows.reduce((sum, row) => sum - (Number(row.sistemaValue) - Number(row.inputValue)), 0);

    this.sistemaValueTotal = sistemaValueTotal;
    this.inputValueTotal = inputValueTotal;
    this.sumTotal = sumTotal;
  }

  updateRows() {
    this.updateData.emit(this.ObtieneTotalEfectivo())
  }

  ObtieneTotalEfectivo(){    
    const efectivoRow = this.rows.find(row => row.nombre_tipopago === "Efectivo");
    if (efectivoRow) {
      return efectivoRow.sistemaValue;
    }
    return 0;
  }

}
